<div *ngIf="show" class="flex justify-center p-2 items-center gap-2"
  [ngClass]="{ 'bg-red-300': !inSchedule, 'bg-primary': inSchedule, 'text-white': inSchedule , 'text-[#9F0000]': !inSchedule}">
  <i class="far fa-clock"></i>
  <span class="font-bold pl-4 lg:px-4">{{ schedule }}</span>&nbsp;
  <a [routerLink]="['/contacto']" class="underline">ver más</a>
</div>